export default function Marquee({ items, className = "", itemClassName = "" }) {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div
      className={`marquee relative overflow-hidden border-y border-white/10 py-4 ${className}`}
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className={`mx-6 flex items-center gap-6 font-mono text-xs uppercase tracking-[0.3em] text-[#616775] ${itemClassName}`}
              >
                {item}
                <span className="text-umber">·</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
